import { ButtonContainer, IDataTableColumn } from "nsitools-react";
import * as React from "react";
import { useHistory } from "react-router";

import { SubActivityApi, SubActivityGridDto, SubActivitySearch } from "../../../../api";
import { ERoutes } from "../../../../ERoutes";
import { EditButton, SearchTablePage, ViewButton } from "../../../../components";
import { useGlobalData } from "../../../../contexts";
import { useApiService, useTl } from "../../../../hooks";
import { ETLCodes } from "../../../../locales";
import { Link } from "react-router-dom";

export interface ISubActivityListPageProps {}

export const SubActivityListPage: React.FunctionComponent<ISubActivityListPageProps> = (props) => {
  const api = useApiService(SubActivityApi);
  const { t } = useTl();
  const history = useHistory();
  const { currentLanguage } = useGlobalData();
  const columns = React.useMemo<IDataTableColumn[]>(
    () => [
      {
        computed: true,
        disableSorting: true,
        fieldName: "actions",
        autoFitContent: true,
        render: (row: SubActivityGridDto) => (
          <ButtonContainer>
            <ViewButton
              minimal={true}
              onClick={() => history.push(`${ERoutes.subActivity}/${row.subActivityId}/detail/view`)}
            />
            <EditButton
              minimal={true}
              onClick={() => history.push(`${ERoutes.subActivity}/${row.subActivityId}/detail/edit`)}
            />
          </ButtonContainer>
        ),
      },
      {
        fieldName: "name",
        header: () => t(ETLCodes.Name),
      },
      {
        fieldName: "showType",
        header: () => t(ETLCodes.ShowType),
      },
      {
        header: () => t(ETLCodes.Activity),
        fieldName: "activity",
        render: (row: SubActivityGridDto) => (
          <Link target="_blank" to={`${ERoutes.activity}/${row.activityId}/detail/view`}>
            {row.activity}
          </Link>
        ),
      },
    ],
    [history, t]
  );

  const addItemFunction = React.useCallback(() => {
    history.push(`${ERoutes.subActivity}/0/detail/edit`);
  }, [history]);

  const searchCriteriasFunction = React.useCallback(() => api.getSearchCriterias(true), [api]);
  const searchFunction = React.useCallback(
    (sObj) => api.baseSearch(SubActivitySearch.fromJS({ ...sObj, languageId: currentLanguage.languageId })),
    [api, currentLanguage.languageId]
  );
  const exportFunction = React.useCallback(
    (sObj) => api.exportXlsFile(SubActivitySearch.fromJS({ ...sObj, languageId: currentLanguage.languageId })),
    [api, currentLanguage.languageId]
  );
  return (
    <SearchTablePage
      columns={columns}
      searchFunction={searchFunction}
      exportFunction={exportFunction}
      getCriteriasFunction={searchCriteriasFunction}
      addFunc={addItemFunction}
      sortKeys={{ name: "ASC" }}
      breadCrumbs={[{ text: t(ETLCodes.SubActivities) }]}
    />
  );
};
